import styled from '@emotion/styled';

const Wrap = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 0 16px;
`;

export default Wrap;
